export const stringMapDefault = {
    calendarDescription: "Date Picker",
    toggleCalendar: "Toggle Calendar",
    closeCalendar: "Close",
    invalidDate: "Invalid Date"
};
